// Selectors for AssetBrowser filters state
// This file will replace selectors/filters.js completely once the rest of the filter types are refactored.

import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { createSelector } from 'reselect';

export const getFilterSelector = (filterName: Filters) => {
  if (!filterName) {
    // All filters
    return (state: any) => state.filters;
  } else {
    // Filter values
    return (state: any) => state.filters[filterName];
  }
};

// Memoized selectors for arrays/objects to avoid unnecessary rerenders
export const selectSources = createSelector(
  (state: any) => state.filters.sources,
  (sources) => sources || [],
);

export const selectAllowedVersions = createSelector(
  (state: any) => state.filters.allowedVersions,
  (allowedVersions) => allowedVersions || [],
);
